module.exports = __webpack_public_path__ + "static/img/example-dy.fc6a1e9e.png";